import {
  ApplicationSpeculationGrantData,
  GrantRow,
  convertGrantAmountToNumber,
} from "@client/pages/round/useSpeculationGrantData";

export function exportSpeculationSettlements(data: {
  applicationSpeculationGrantData: ApplicationSpeculationGrantData;
  totalGrantAmount: number;
  settlementBudget: number;
  funderId: string;
}) {
  let rows: string[][] = [];
  rows.push([
    "orgCode",
    "Receiving Charity",
    "Grant ID (same for multi-sigs)",
    "Speculation Grantor",
    "Grant Amount",
    "salePrice",
  ]);

  for (const [sffApplicationId, grantData] of Object.entries(
    data.applicationSpeculationGrantData,
  )) {
    const grantRows: GrantRow[] = [];
    for (const multiGrant of Object.values(grantData.simultaneousGrants)) {
      for (const grantRow of multiGrant.grants) {
        grantRows.push(grantRow);
      }
    }

    for (let grantRow of grantRows) {
      const orgCode = (grantRow["Org Name (auto)"] as string) || "";
      const charity =
        (grantRow["Receiving Charity or other entity"] as string) || "";
      const grantId = sffApplicationId;
      const grantor = (grantRow["Speculation Grantor"] as string) || "";

      const grantAmount = convertGrantAmountToNumber(
        grantRow["Speculator Amount"],
      );
      const salePrice =
        (grantRow.utility && grantRow.utility * data.settlementBudget) || 0;

      rows.push([
        orgCode,
        charity,
        grantId,
        grantor,
        (Math.round(grantAmount / 1000) * 1000).toString(),
        (Math.round(salePrice / 1000) * 1000).toString(),
      ]);
    }
  }

  const tsv = rows
    .map((row) => row.map((item) => item.replace(/\t/g, " ")).join("\t"))
    .join("\n");

  return tsv;
}
